import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const Layout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';

  return (
    <div className="relative flex min-h-screen w-full flex-col bg-background-dark overflow-x-hidden text-white">
      <div className="mx-auto flex w-full max-w-md flex-col flex-1 min-h-[100dvh]">
        {/* Header */}
        <header className="flex items-center justify-between p-6 pb-4 z-50">
          {isHome ? (
            <span className="material-symbols-outlined text-3xl text-primary">
              workspaces
            </span>
          ) : (
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-white/70 hover:text-white transition-colors"
            >
              <span className="material-symbols-outlined text-2xl mr-1">arrow_back</span>
            </button>
          )}

          <h2 className="flex-1 text-center text-lg font-bold leading-tight tracking-[-0.015em] text-white">
            MONOSPACE
          </h2>

          {/* Spacer to balance the left icon/back button */}
          <div className="w-8"></div>
        </header>

        {/* Content */}
        <main className="flex flex-1 flex-col gap-6 p-4 pt-4 animate-fadeIn">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;